import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=4794eba4&"
import script from "./ValidationErrorsVue.ts?vue&type=script&lang=ts&"
export * from "./ValidationErrorsVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports